import { create } from "zustand";

/**
 * 列表頁的篩選條件 — 跨頁存活的 client 狀態(票 26)。
 *
 * 為什麼不是頁內 `useState`:離開列表去看一筆詳情、或去別的模組查個東西再回來,
 * 剛才篩到一半的條件就整組沒了,要重篩一次。篩選條件**本來就該跨頁活著**,
 * 歸在「單頁暫態」那一類是歸錯層(分工見 `uiStore.js` 的 JSDoc)。
 *
 * 為什麼不放進 `uiStore`:那裡是一格一格具名的全域 UI 狀態(側欄收合、徽章數…),
 * 每加一頁就要多兩個欄位。這裡是「以頁為鍵的一袋值」,形狀由各頁自己決定,
 * 混在一起會讓 uiStore 隨頁面數量無限膨脹。
 *
 * **刻意不做 persist**:「跨頁回來」指的是站內導覽;重整＝重新開始。
 * 存進 storage 會讓使用者隔天打開還被上次的條件篩著,更不直覺,也多一條清除責任。
 *
 * 用法一律透過 `pages/DCKeeper/useStickyFilters.js`,不要直接讀這個 store。
 */
export const useListFilterStore = create((set) => ({
  /** { [pageKey]: filtersObject } */
  byKey: {},

  setFor: (key, value) => set((s) => ({ byKey: { ...s.byKey, [key]: value } })),

  /**
   * 清掉全部。兩個呼叫端:
   * 1. `sessionStore.logout()` —— 條件可能含人名/關鍵字,不能讓下一個登入的人看到
   *    (與登出丟選單快取同一道防線)。
   * 2. 測試的全域 beforeEach —— store 是 module 級單例,不清會跨測試污染。
   */
  clearAll: () => set({ byKey: {} }),
}));

/** 給非元件情境用(logout、測試),不必拿 hook */
export const resetListFilters = () => useListFilterStore.getState().clearAll();
